import { z } from 'zod';
/** A ticker line has to be readable in the seconds it takes to cross the screen. */
export const MAX_MESSAGE_LENGTH = 140;
export const MAX_AUTHOR_LENGTH = 60;
export const createMessageSchema = z.object({
    body: z.string().trim().min(1).max(MAX_MESSAGE_LENGTH),
    authorName: z.string().trim().max(MAX_AUTHOR_LENGTH).optional(),
});
//# sourceMappingURL=message.js.map